import { useState } from "react";
import { useParams } from "react-router-dom";
import { getAccessToken, postData } from "../common/MSALHelper";
import { useMsal } from "@azure/msal-react";

export default function AddContribution({hideAddContribution, refreshData}) {
    const { instance, accounts } = useMsal();
    const { member_id } = useParams();
    const contribution_id = 0
    const currentDate = new Date();
    const [formData, setFormData] = useState({
        ParishionerID: member_id,
        ID: contribution_id,
        Amount: '',
        Date: currentDate.toISOString().split('T')[0],
        Mark: false,
        Note: '',
        ThankYouNoteSent: false
    });

    const onSubmit = async (event) => {
        event.preventDefault();

        try {
            getAccessToken(instance, accounts).then((response) => {
                let accessToken = response;
                postData(accessToken, `/contribution`, response => {
                    if (response.ok) {
                        // Contribution updated successfully
                        console.log('Contribution updated successfully');
                        hideAddContribution();
                        refreshData();
                    } else {
                        // Handle error response
                        console.error('Failed to update contribution');
                    }
                }, data => {
                }, JSON.stringify({
                    ...formData,
                    // oldAmount: '', // Provide old Amount
                    // oldDate: '',   // Provide old Date
                    // oldMark: '',   // Provide old Mark
                    // oldNote: '',   // Provide old Note
                    // oldThankYouNoteSent: '' // Provide old thank you note sent
                })
                );
            });
        } catch (error) {
            // Handle fetch error
            console.error('Error updating contribution:', error);
        }
    };

    const onCancel = () => {
        hideAddContribution();
        // refreshData();
    }

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        let newValue = value;

        if (name === 'Amount') {
            // Validate Amount to allow only numbers with optional decimal point
            newValue = value.replace(/[^0-9.]/g, ''); // Allow only digits and dot
            const decimalCount = (value.match(/\./g) || []).length;
            if (decimalCount > 1 ) {
                // Allow only one decimal point
                newValue = formData.Amount;
            }
        } else {
            newValue = type === 'checkbox' ? checked : value;
        }
        setFormData({ ...formData, [name]: newValue });
    };

    const handleBlur = (event) => {
        if (formData.Amount.endsWith(".")) {
            formData.Amount = formData.Amount.substring(0, formData.Amount.length - 1);
            setFormData({...formData})
        }
    }

    return <form id="contributionForm" onSubmit={onSubmit}>
        <label htmlFor="contribution_id">ID: </label><br />
        <input type="text" id="contribution_id" name="contribution_id" required readOnly value="(new)" />
            <input type="hidden" id="hidden_id" name="id" value={contribution_id} /><br />

        <label htmlFor="Amount">Amount:</label><br />
        <input type="text" id="Amount" name="Amount" required onChange={handleChange} value={formData.Amount} onBlur={handleBlur} /><br />

        <label htmlFor="Date">Date:</label><br />
        <input type="Date" id="Date" name="Date" required onChange={handleChange} value={formData.Date} /><br />

        <label htmlFor="Mark">Mark:</label><br />
        <input type="checkbox" id="Mark" name="Mark" onChange={handleChange} /><br />

        <label htmlFor="Note">Note:</label><br />
        <input type="text" id="Note" name="Note" onChange={handleChange} /><br />

        <label htmlFor="ThankYouNoteSent">Thank You Note Sent:</label><br />
        <input type="checkbox" id="ThankYouNoteSent" name="ThankYouNoteSent" onChange={handleChange} /><br />

        <button type="submit">Add</button>
        <button onClick={onCancel}>Cancel</button>
    </form>;
}